import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { GeoEventEditorLayout } from 'features/geoEvents/components/GeoEventEditorLayout';
import { WildfireForm } from './WildfireForm/WildfireForm';

export const CreateEditWildfire = (
  props: RouteComponentProps<{ geoEventId?: string }>,
): JSX.Element => {
  const {
    match: {
      params: { geoEventId },
    },
  } = props;
  const { t } = useTranslation();

  return (
    <GeoEventEditorLayout
      id={geoEventId}
      createHelmetTitle={t('createEditWildfire.title.add')}
      editHelmetTitle={t('createEditWildfire.title.edit')}
      renderSuccess={(geoEvent) => (
        <WildfireForm wildfire={geoEvent as unknown as Wildfire} />
      )}
    />
  );
};
